import React from "react";
import * as styles from "../../styles/menu/fancyBorder.module.css";

function FancyBorder({ children, height,color, className }) {
  return (
    <div
      style={{ height: height }}
      className={`${styles.container} ${className}`}
    >
      <div className={styles.innerBorder}>
        <div style={{ overflowY: "scroll", height: `100%`,overflowX:'hidden' }}>{children}</div>
        <div className={styles.topBorder}></div>
        <div className={styles.bottomBorder}></div>
      </div>
    </div>
  );
}

export default FancyBorder;
